import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./rich_text_styles.css";


export default function RichTextPage({ name, defaultValue = "" }) {
  const [value, setValue] = useState(defaultValue);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "clean"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "align",
    "link",
  ];

  const safeValue =
    typeof value === "string" ? value.replace(/&nbsp;/g, "\u00A0") : value;

  const normalizedValue =
    typeof value === "string"
      ? value.replace(/ {2,}/g, (match) => match.replace(/ /g, "\u00A0"))
      : value;

  return (
    <>
      <div className="editor-card">
        <ReactQuill
          className="my-quill"
          theme="snow"
          value={safeValue}
          onChange={setValue}
          modules={modules}
          formats={formats}
          placeholder=""
        />
      </div>

      <input
        name={name}
        value={normalizedValue}
        onChange={() => {}}
        className="hidden"
      />
    </>
  );
}
